import { HttpErrorResponse, HttpInterceptorFn, type HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { ProblemDetails } from '@easihub/esm';
import { catchError } from 'rxjs';
import { CLIENT_CONFIG } from '../dependency-injection';
import { isBrowser } from '../utilities/platform-type';

function shouldIntercept(req: HttpRequest<unknown>) {
  return isBrowser() || isApiRequest(req);
}

function isApiRequest(req: HttpRequest<unknown>) {
  return req.url.startsWith(inject(CLIENT_CONFIG).api);
}

export const easihubApiInterceptor: HttpInterceptorFn = (req, next) => {
  if (!shouldIntercept(req))
    return next(req);

  req = req.clone({ withCredentials: true });

  return next(req)
    .pipe(
      catchError(err => {
        let errorSource;

        if (err instanceof HttpErrorResponse) {
          if (err.headers.get('content-type')?.includes('application/problem+json')) {
            if (typeof err.error === 'string') {
              errorSource = JSON.parse(err.error);
            }
            else {
              errorSource = err.error;
            }
          }
        }
        else {
          errorSource = err;
        }

        let pd;
        try {
          pd = ProblemDetails.fromObject(errorSource);
        }
        catch {
          pd = new ProblemDetails();
          pd.type = 'unknown-error';
          pd['error'] = errorSource;
          pd['url'] = req.url;
        }
        throw pd;
      })
    );
};